import * as React from 'react';
import style from './SearchResultsEmptyState.scss';
import { Text, WEIGHTS, SIZES } from '../../../../PageElements/Text';

export const SearchResultsEmptyState = ({ searchTerm }) => {
  return (
    <div className={style.emptyState}>
      <Text
        tagName="span"
        size={SIZES.small}
        dataHook="search-results-empty-state"
      >
        We couldn't find any results for&nbsp;
      </Text>
      <Text size={SIZES.small} weight={WEIGHTS.bold} tagName="span">
        "{searchTerm}"
      </Text>
      <Text
        tagName="span"
        size={SIZES.small}
        dataHook="search-results-empty-state-1"
      >
        . Check for typos or try different keywords.
      </Text>
    </div>
  );
};
